import cloudModule from './../cloud.module';
import template from './registration.component.html';
import style from './registration.component.scss';

export default cloudModule.component('registration', {
    template: template,
    style: style,
    controller: registrationComponent
});

function registrationComponent(
    $window,
    $state,
    $stateParams,
    $scope,
    acsApiService,
    asLoadingMask,
    asNotifier,
    textResources,
    jwtHelper,
    $timeout
) {
    const vm = this;

    vm.showExpiredMessage = false;

    if (
        $stateParams.instanceGuid == undefined ||
        $stateParams.origin == undefined
    ) {
        $state.go('app');
        return;
    }

    vm.$onInit = () => {
        asLoadingMask.show();

        acsApiService
            .createCloudRegistration($stateParams.instanceGuid)
            .then(
                data => {
                    vm.payload = data.registrationToken;

                    const now = new Date();
                    const expiredDate = jwtHelper.getTokenExpirationDate(
                        vm.payload
                    );

                    vm.showExpiredMessage = expiredDate < now;

                    if (!vm.showExpiredMessage) {
                        const millisecondsUntilJwtExpired = expiredDate - now;

                        $timeout(() => {
                            $scope.$evalAsync(function() {
                                vm.showExpiredMessage = true;
                            });
                        }, millisecondsUntilJwtExpired);
                    }
                },
                () => {
                    asNotifier.error(
                        `There was an error generating the registration code. Please contact Appspace Support for further assistance.`
                    );
                }
            )
            .finally(() => {
                asLoadingMask.hide();
            });
    };

    vm.close = () => {
        $window.close();
    };
}



// WEBPACK FOOTER //
// ./modules/cloud/registration/registration.component.js